export const mfRoutes = [
  {
    path: '/about/',
    name: 'about',
    component: () => import('@/pages/about/ui/AboutPage.vue'),
  },
  {
    path: '/about/:slug/',
    name: 'about-content',
    component: () => import('@/pages/about-content/ui/AboutContentPage.vue'),
  },
];

export default mfRoutes;
